import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { logError } from '../../services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-auth-callback',
  template: '<ng-casto-loader></ng-casto-loader>',
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly customerService: CustomerService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    // Toujours consommée, pour qu'une URL mémorisée ne ressorte pas à une connexion suivante.
    const storedReturnUrl = this.customerService.consumeLoginReturnUrl();
    const returnUrl = this.normalizeReturnUrl(this.route.snapshot.queryParamMap.get('returnUrl') ?? storedReturnUrl);

    try {
      // Aucun jeton HomeByMe n'est demandé ici : le compte HBM n'est créé qu'au premier
      // configurateur ouvert. Se connecter ne coûte donc rien côté HomeByMe.
      await this.customerService.initializeCiamSession();
      await this.router.navigateByUrl(returnUrl);
    } catch (error) {
      logError(error);
      await this.router.navigate(['/'], { queryParams: { ciamError: 'callback' } });
    }
  }

  private normalizeReturnUrl(returnUrl: string | null): string {
    if (!returnUrl || !returnUrl.startsWith('/') || returnUrl.startsWith('//')) {
      return '/';
    }

    return returnUrl;
  }
}
